export default [
  'click',
  'dblclick',
  'mousedown',
  'mouseup'
]
